import { render, staticRenderFns } from "./TreeFolderIconCollapsed.vue?vue&type=template&id=55ea7eb0"
import script from "./TreeFolderIconCollapsed.vue?vue&type=script&lang=js"
export * from "./TreeFolderIconCollapsed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports